/**
 * Created by mac on 12/14/20
 */

const UnitView = cc.Node.extend({
    ctor: function (unit) {
        this._super();

        this.unit = unit;
        this.layer = Map2d.LAYER_UNITS;

        const composite = this.unit.findComponent(Composite);
        if (composite) {
            this.composite = composite;
        }

        this.additionalViews = {};

        const sprite = UnitView.getUnitImage(unit, {
            keepLazy: true
        });

        this.setUnitImage(sprite);

        unit.setView(this);

        if (cleverapps.config.demoMode && cleverapps.unitsDemoMode.selectedFamily() === unit.code) {
            unit.highlight();
        }

        this.createComponentViews();
        this.restoreState();
    },

    createComponentViews: function () {
        this.unit.components.forEach(function (component) {
            ViewFactory(component, this);
        }, this);
    },

    shouldMarkAsLast: function () {
        if (this.unit.findComponent(ThirdElement)) {
            return false;
        }
        
        return this.unit.isLast() || this.unit.getData().unmergeable;
    },

    hasBoneAnchor: function () {
        return this.sprite.getAnchorBone && this.sprite.getAnchorBone();
    },

    setUnitImage: function (sprite) {
        if (this.sprite) {
            this.sprite.removeFromParent();
        }
        this.sprite = sprite;

        sprite.saveStack = true;

        const spriteSize = sprite.getContentSize();
        const unitSize = {
            width: Math.max(cleverapps.styles.UnitView.minimalSize.width, spriteSize.width),
            height: Math.max(cleverapps.styles.UnitView.minimalSize.height, spriteSize.height)
        };

        if (sprite instanceof LazyAsset && !sprite.isLoaded()) {
            sprite.whenAssetLoaded(() => {
                if (Map2d.currentMap) {
                    Map2d.currentMap.getMapView().addTile(Map2d.LAYER_UNITS, this.unit.x, this.unit.y, this);
                }
            });
        }

        const useAnchorBone = this.hasBoneAnchor();
        if (useAnchorBone) {
            const spriteAnchor = sprite.getAnchorPoint();
            const adjustedAnchorX = (spriteAnchor.x * spriteSize.width) / unitSize.width;
            const adjustedAnchorY = (spriteAnchor.y * spriteSize.height) / unitSize.height;
            this.setAnchorPoint(adjustedAnchorX, adjustedAnchorY);
            sprite.setAnchorPoint(0.5, 0);
        } else {
            const styles = UnitView.getUnitAnchor(this.unit, {
                podiumAnchors: this.unit.code === "landmark" && cleverapps.meta.selectedLocationId() === "main"
            });
            this.setAnchorPoint(0.5, styles.y);
            sprite.setAnchorPoint(styles.x, 0);
        }

        this.setContentSize2(unitSize);
        sprite.setAlignment(this.width / 2, (unitSize.height - this.sprite.height) / 2);

        this.addChild(sprite);

        if (this.composite) {
            this.composite.removeParts();
            this.composite.createParts();
        }
    },

    restoreState: function () {
        this.createPrizeView();
        this.createPoints();
        this.updateCustomerMark();
    },

    cleanup: function () {
        this._super();

        this.unit.removeView();
    },

    removeFromParent: function (cleanup) {
        if (this.startDragDelta && this._parent && (cleanup === undefined || cleanup)) {
            cleverapps.throwAsync("Remove dragging unit view");
        }

        if (this.composite) {
            this.composite.removeParts();
        }

        this._super(cleanup);
    },

    clearAnimations: function () {
        this.unit.clearAnimations();

        ["squeezeAction", "mergeAction", "mergeAnimateAction", "addAnimationAction"].forEach(function (actionName) {
            const action = this[actionName];
            if (action && !action.isDone()) {
                this.stopAction(action);
            }
            delete this[actionName];
        }, this);
    },

    setVisible: function (visible) {
        cc.Node.prototype.setVisible.call(this, visible);

        if (this.composite) {
            this.composite.setVisible(visible);
        }
    }
});

UnitView.prototype.checkTouchInside = function (touch, isTallUnit) {
    if (!this.isDisplayed()) {
        return false;
    }

    const point = this.convertTouchToNodeSpace(touch);

    return UnitView.targetContainPoint(this, point, isTallUnit);
};

UnitView.prototype.showAdditionalViews = function () {
    const mapView = Map2d.currentMap.getMapView();

    for (const type in this.additionalViews) {
        const view = this.additionalViews[type];
        view.replaceParent(this);
        view.setAlignment(view.basePosition);
        mapView.upAdditionalViewAboveClouds(this, view);

        this.additionalViews[type].animateAppear();
    }
};

UnitView.prototype.hideAdditionalViews = function () {
    for (const type in this.additionalViews) {
        this.additionalViews[type].animateHide();
    }
};

UnitView.prototype.removeAdditionalViews = function () {
    Object.keys(this.additionalViews).forEach((type) => {
        this.removeAdditionalView(type, true);
    });

    InfoView.Clear(this.unit);
};

UnitView.prototype.onRemove = function () {
    if (typeof Map2dLocation !== "undefined" && !Map2dLocation.currentLocation.stopped && Map2d.currentMap.workers.findAssigned(this.unit)) {
        cleverapps.throwAsync("Remove worker assigned unit");
    }

    this.removeFromParent();
};

UnitView.prototype.onTradeSell = function (callback) {
    this.runAction(new cc.Sequence(
        new cc.DelayTime(0.5),
        new cc.CallFunc(() => {
            const shine = new cleverapps.Spine(bundles.merge.jsons.trade_exchange_json);
            shine.setLocalZOrder(1);
            shine.setAnimation(0, "use", false);
            shine.setCompleteListenerRemove(callback);
            shine.setSafeToRemove();

            const map2dView = Map2d.currentMap.getMapView();
            map2dView.alignViewInGrid(this.unit.x, this.unit.y, shine);
            map2dView.animations.addChild(shine);
        }),
        new cc.ScaleTo(0.5, 0.2).easing(cc.easeBackIn()),
        new cc.RemoveSelf()
    ));
};

UnitView.prototype.onTradeBuy = function (callback) {
    this.unit.hideAdditionalViews();
    this.setScale(0);
    this.runAction(new cc.Sequence(
        new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut()),
        new cc.CallFunc(() => {
            this.unit.showAdditionalViews();
        }),
        new cc.DelayTime(1),
        new cc.CallFunc(callback)
    ));
};

UnitView.prototype.getSpawnStart = function (parentUnit, options) {
    const map2dView = Map2d.currentMap.getMapView();

    let start;
    if (options.fromNode) {
        const cellPos = map2dView.alignInGrid(this.unit.x, this.unit.y);
        start = parentUnit.parent ? this.getRelativeCoordinates(parentUnit) : cc.p(parentUnit);
        start.x -= cellPos.x;
        start.y -= cellPos.y;
    } else {
        start = cc.pSub(map2dView.toScreen(parentUnit.x, parentUnit.y), map2dView.toScreen(this.unit.x, this.unit.y));
        start.y += cleverapps.styles.Map2dView.cell.height / 2;
        const multiCell = parentUnit.findComponent && parentUnit.findComponent(MultiCell);
        if (multiCell) {
            const centerDelta = multiCell.getCenter();
            start.x += centerDelta.x;
            start.y += centerDelta.y;
        }
    }

    const defaultStartScale = cleverapps.config.name === "garden" ? 0.7 : 0.3;
    const startScale = options.startScale || defaultStartScale;

    this.setScaleX(typeof startScale === "object" ? startScale.x : startScale);
    this.setScaleY(typeof startScale === "object" ? startScale.y : startScale);

    if (options.startAnchors) {
        start.x += this.scaleX * this.width * (this.anchorX - options.startAnchors.anchorX);
        start.y += this.scaleY * this.height * (this.anchorY - options.startAnchors.anchorY);
    }

    return map2dView.alignPositionInGrid(this.unit.x, this.unit.y, start);
};

UnitView.prototype.spawn = function (parentUnit, id, options) {
    const callback = options.callback || function () {};

    this.stopAllActions();
    this.unit.hideAdditionalViews();

    const realParent = this.getParent();
    const movingNode = cleverapps.Scenes.GetMovingNode(this);
    this.replaceParentSamePlace(movingNode, {
        keepScale: true
    });

    if (Unit.IsApplicable({ code: "dwarf" }, parentUnit) && (Map2dLocation.currentLocation.tutorial.checkConditions({ unit: parentUnit }) || cleverapps.tutorial.checkConditions({ unit: parentUnit }))) {
        this.setVisible(false);
        this.runAction(new cc.Sequence(
            StandartAnimations.showUp(this, { flash: true }),
            new cc.ReplaceParent(realParent)
        )).setFinalize(callback);
    } else {
        const start = this.getSpawnStart(parentUnit, options);
        const dist = { x: this.x - start.x, y: this.y - start.y };
        this.setAlignment(start.x, start.y);

        let path;
        if (options.path || cleverapps.styles.UnitView.enableSpawnPath) {
            path = new cleverapps.Particles(bundles.particle.jsons.particles_spawn_json, bundles.particle.frames.particle_texture);
            movingNode.addChild(path);
            path.followTarget(this);
        }

        const time = 0.6 * (0.5 + 0.001 * cc.pLength(dist));

        const appearAnimation = new cc.Spawn(
            new cc.ScaleTo(time, 1).easing(cc.easeOut(2)),
            new cc.JumpAnimation(time, this, dist, cleverapps.styles.UnitView.spawnHeight)
        );

        const dScale = this.height < cleverapps.styles.UnitView.squeeze.smallHeight ? 0.1 : 0.05;
        const finishAnimation = ["heroes", "wooden"].indexOf(cleverapps.config.ui) !== -1 ? StandartAnimations.ballEffect(this, realParent, { dScale }) : StandartAnimations.squeeze(this, { dScale });

        this.runAction(new cc.Sequence(
            new cc.Hide(),
            new cc.DelayTime(id * 0.1),
            new cc.Show(),
            appearAnimation,
            cleverapps.effects.fireAction("merge.spawn.landing"),
            finishAnimation,
            new cc.ReplaceParent(realParent),
            new cc.CallFunc(this.unit.showAdditionalViews.bind(this.unit))
        )).setFinalize(() => {
            if (path) {
                path.stop();
            }

            callback();
        });
    }
};

UnitView.prototype.showUp = function (callback) {
    if (!(this.sprite instanceof cleverapps.Spine && this.sprite.hasAnimation("showup"))) {
        callback();
        return;
    }

    const savedParent = this.getParent();
    this.replaceParentSamePlace(Map2d.currentMap.getMapView().animations, {
        keepScale: true
    });

    Map2d.currentMap.focusOnUnit(this.unit, {
        allowScrollWithFocus: true
    });

    cleverapps.effects.fire([
        `unit.showup.${this.unit.code}.${this.unit.stage}`,
        `unit.showup.${this.unit.code}`
    ], this);

    const timeScale = Map2d.animationsTimeScale();
    this.sprite.setTimeScale(1 / timeScale);
    this.sprite.setAnimation(0, "showup", false);
    this.sprite.setCompleteListenerOnce(() => {
        this.sprite.setTimeScale(1);
        this.replaceParentSamePlace(savedParent, {
            keepScale: true
        });

        this.sprite.setAnimation(0, "idle", true);

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.5 * timeScale),
            new cc.CallFunc(callback)
        ));
    });
};

UnitView.prototype.outline = function (restore) {
    if (!cleverapps.skins.getSlot("outlineUnit")) {
        return;
    }

    if (restore && this.sprite.outlineSprite && (!InfoView.IsDisplayedFor(this.unit) || this.getAdditionalView("ingredients"))) {
        this.sprite.outlineSprite.removeFromParent();
        delete this.sprite.outlineSprite;

        if (this.composite) {
            this.composite.updateOutline();
        }
    }

    if (!restore && !this.sprite.outlineSprite) {
        this.runAction(new cc.Sequence(
            StandartAnimations.outline(this.sprite),
            new cc.CallFunc(() => {
                if (this.composite) {
                    this.composite.updateOutline();
                }
            })
        ));
    }
};

UnitView.prototype.squeeze = function () {
    if (this.squeezeAction && !this.squeezeAction.isDone()) {
        this.stopAction(this.squeezeAction);
    }

    const dScale = this.height < cleverapps.styles.UnitView.squeeze.smallHeight ? 0.1 : 0.05;
    this.squeezeAction = this.runAction(StandartAnimations.squeeze(this, { dScale }));
};

UnitView.prototype.isClickable = function () {
    if (!Map2d.currentMap.getMapView().containsView(this)) {
        return;
    }

    if (this.unit.getData().clickable === false) {
        return;
    }

    if (!this.sprite.isVisible()) {
        return;
    }

    if (this.unit.isLockedByTutorial({ click: true })) {
        return;
    }

    return true;
};

UnitView.prototype.handleClick = function () {
    if (!this.isClickable()) {
        return false;
    }

    if (cleverapps.config.demoMode) {
        InfoView.SqueezeAndDisplay(this.unit);
        if (!cleverapps.unitsDemoMode.isSelectedUnit(this.unit)) {
            cleverapps.unitsDemoMode.clearSelectUnit();
        }

        cleverapps.unitsDemoMode.selectUnit(this.unit);
        return true;
    }

    if ((!InfoView.IsDisplayedFor(this.unit) || !InfoView.IsPreventClicks()) && this.unit.handleClick()) {
        InfoView.CloseInfo();
        return true;
    }

    cleverapps.effects.fire("ui.button.click");

    InfoView.SqueezeAndDisplay(this.unit);

    return true;
};

UnitView.prototype.startDidMerged = function () {
    const styles = cleverapps.styles.UnitView;

    const mapView = Map2d.currentMap.getMapView();
    const json = cleverapps.skins.getSlot("merge_animation_json") || bundles.merge_animations.jsons.merge_animation_json;

    const animationAbove = new cleverapps.Spine(json);
    animationAbove.setAlignment(styles.mergeAnimation);
    animationAbove.setCompleteListenerRemove();
    animationAbove.setSafeToRemove();
    mapView.alignViewInGrid(this.unit.x, this.unit.y, animationAbove);
    mapView.animations.addChild(animationAbove);

    animationAbove.runAction(new cc.Sequence(
        new cc.DelayTime(styles.mergeAnimation.delay),
        new cc.CallFunc(() => {
            animationAbove.setAnimation(0, "animation", false);
        })
    ));

    if (!this.unit.isMultiCell() && cleverapps.Spine.hasAnimation("animation_below", json)) {
        const animationBelow = new cleverapps.Spine(json);
        animationBelow.setAlignment(styles.mergeAnimationBelow);
        animationBelow.setCompleteListenerRemove();
        animationBelow.setSafeToRemove();
        animationBelow.setLocalZOrder(-1);
        mapView.addTile(Map2d.LAYER_UNITS, this.unit.x, this.unit.y, animationBelow);

        animationBelow.runAction(new cc.Sequence(
            new cc.DelayTime(styles.mergeAnimationBelow.delay),
            new cc.CallFunc(() => {
                animationBelow.setAnimation(0, "animation_below", false);
            })
        ));
    }
};

UnitView.prototype.showFreshAnimation = function () {
    const animations = Map2d.currentMap.getMapView().animations;

    const unitView = UnitView.getUnitImage(this.unit, { preferStatic: true });
    unitView.setAlignment(animations.convertToNodeSpace(this.parent.convertToWorldSpace(this.getPosition())));
    unitView.setVisible(false);
    animations.addChild(unitView);

    unitView.runAction(new cc.Sequence(
        new cc.DelayTime(0.7),
        new cc.Show(),
        StandartAnimations.animateCollect(unitView, "unitsLibrary", {
            path: true,
            adjustToTarget: true,
            collectEffect: true,
            effect: "menubar.exp.fly_finish"
        }),
        new cc.RemoveSelf()
    ));
};

UnitView.prototype.dialogueAnimation = function (animationName, defaultAnimation) {
    const animation = this.getAnimation();
    if (!animation) {
        return;
    }

    const loading = animation instanceof LazyAsset && !animation.isLoaded();
    if (!loading && animation.hasAnimation(animationName)) {
        animation.setAnimation(0, animationName, false);
        animation.setCompleteListener(() => {
            UnitView.applyDefaultAnimation(animation, this.unit, defaultAnimation);
        });
    }
};

UnitView.prototype.didMerged = function (startPoint, index) {
    const styles = cleverapps.styles.UnitView;
    const map2dView = Map2d.currentMap.getMapView();

    this.stopAllActions();
    this.removePath();
    this.setVisible(false);
    this.unit.hideAdditionalViews();

    const delay = (cleverapps.gameModes.axemerge ? 0.3 : styles.didMerge.delay) + 0.1 * index;

    let time, moveAnimation, scaleAnimation;

    if (index === 0 && !this.unit.isMultiCell()) {
        time = 0.48;
        moveAnimation = new cc.DelayTime(0);
        scaleAnimation = new cc.Sequence(
            new cc.CallFunc(() => {
                this.setScale(0.1);
            }),
            new cc.ScaleTo(0.2, 1.2).easing(cc.easeOut(2)),
            new cc.ScaleTo(0.2, 1).easing(cc.easeIn(2)),
            new cc.CallFunc(() => {
                this.unit.showAdditionalViews();
            })
        );
    } else {
        let start = map2dView.toScreen(startPoint.x - this.unit.x, startPoint.y - this.unit.y);
        start = map2dView.alignPositionInGrid(this.unit.x, this.unit.y, start);

        const dist = { x: this.x - start.x, y: this.y - start.y };

        time = 0.5 * (0.5 + 0.002 * Math.sqrt(dist.x * dist.x + dist.y * dist.y));
        if (time > 0.4) {
            time = 0.4;
        }

        moveAnimation = new cc.Sequence(
            new cc.CallFunc(() => {
                this.setPosition(start.x, start.y);
            }),
            new cc.JumpAnimation(time, start, dist, styles.mergeSpawnHeight)
        );

        scaleAnimation = new cc.Sequence(
            new cc.CallFunc(() => {
                this.setScale(0.5);
            }),
            new cc.ScaleTo(time, 1).easing(cc.easeOut(2)),
            new cc.CallFunc(() => {
                this.squeeze();
                this.unit.showAdditionalViews();
            })
        );
    }

    if (cleverapps.config.name === "fairy") {
        scaleAnimation = new cc.Sequence(
            new cc.CallFunc(() => {
                this.setScale(0.2);
            }),
            new cc.ScaleTo(time * 0.7, 1.09).easing(cc.easeIn(1.6)),
            new cc.ScaleTo(time * 0.3, 0.95),
            new cc.CallFunc(() => {
                this.unit.showAdditionalViews();
            }),
            new cc.ScaleTo(0.23, 1.02).easing(cc.easeOut(1.6)),
            new cc.ScaleTo(0.4, 1)
        );
    }

    const parent = this.getParent();
    this.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(this));

    this.mergeAction = this.runAction(new cc.Sequence(
        new cc.DelayTime(delay),
        new cc.Spawn(
            new cc.Show(),
            moveAnimation,
            scaleAnimation
        )
    ));
    this.mergeAction.setFinalize(() => {
        this.setPosition(map2dView.alignInGrid(this.unit.x, this.unit.y));
        this.replaceParentSamePlace(parent);
    });
};

UnitView.prototype.onHighlightDragTarget = function () {
    const styles = cleverapps.styles.DraggableView;

    this.setImageOpacity(255, true);
    this.markDragTarget();

    const draggableArrow = new cc.Sprite(bundles.merge_animations.frames.pointing_arrow);
    draggableArrow.setAlignment(styles.arrow);

    this.animateAppearAdditionalView("arrow", draggableArrow);

    draggableArrow.runAction(new cc.RepeatForever(new cc.Sequence(
        new cc.MoveBy(1, 0, styles.arrow.delta).easing(cc.easeInOut(1.7)),
        new cc.MoveBy(1, 0, -styles.arrow.delta).easing(cc.easeInOut(1.7))
    )));

    this.draggableArrow = draggableArrow;

    const prizeView = this.getAdditionalView("prize");
    if (prizeView) {
        prizeView.hide();
    }
};

UnitView.prototype.onUnhighlightDragTarget = function () {
    if (this.draggableArrow) {
        this.restoreOpacity();
        this.markNormal();

        this.removeAdditionalView("arrow");

        this.draggableArrow = undefined;

        const prizeView = this.getAdditionalView("prize");
        if (prizeView) {
            prizeView.animateAppear();
        }
    }
};

UnitView.prototype.onPointToUnit = function () {
    const styles = cleverapps.styles.DraggableView;

    this.setImageOpacity(255, true);
    this.markDragTarget();

    this.draggableArrow = new cc.Sprite(bundles.merge_animations.frames.pointing_arrow);
    this.draggableArrow.setAlignment(styles.arrow);

    this.animateAppearAdditionalView("arrow", this.draggableArrow);

    this.draggableArrow.runAction(new cc.Sequence(
        new cc.Repeat(new cc.Sequence(
            new cc.MoveBy(0.5, 0, styles.arrow.delta).easing(cc.easeInOut(1.7)),
            new cc.MoveBy(0.5, 0, -styles.arrow.delta).easing(cc.easeInOut(1.7))
        ), 2),
        new cc.CallFunc(this.onUnhighlightDragTarget.bind(this))
    ));
};

UnitView.prototype.stopAnimateMerge = function (target) {
    if (this.mergeAnimateAction && !this.mergeAnimateAction.isDone()) {
        this.stopAction(this.mergeAnimateAction);
        delete this.mergeAnimateAction;
    }
    if (this.unit !== target && (!this.mergeAction || this.mergeAction.isDone())) {
        this.mergeAnimateAction = this.runAction(new cc.Spawn(
            new cc.MoveTo(0.1, Map2d.currentMap.getMapView().alignInGrid(this.unit.x, this.unit.y)),
            new cc.ScaleTo(0.1, 1)
        ));
    } else {
        this.mergeAnimateAction = this.runAction(new cc.ScaleTo(0.1, 1));
    }
};

UnitView.prototype.merge = function (target) {
    const mapView = Map2d.currentMap.getMapView();
    this.replaceParentSamePlace(mapView.animations);
    const targetPos = mapView.alignInGrid(target.x, target.y);

    if (cleverapps.config.name === "fairy") {
        this.runAction(new cc.Sequence(
            new cc.MoveTo(0.3, targetPos).easing(cc.easeIn(2)),
            new cc.RemoveSelf()
        ));
    } else {
        this.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.MoveTo(0.3, targetPos).easing(cc.easeIn(2)),
                new cc.ScaleTo(0.3, 0).easing(cc.easeBackIn())
            ),
            new cc.RemoveSelf()
        ));
    }
};

UnitView.prototype.startAnimateMerge = function (target) {
    if (this.mergeAnimateAction && !this.mergeAnimateAction.isDone()) {
        this.stopAction(this.mergeAnimateAction);
        delete this.mergeAnimateAction;
    }

    const actions = [];
    actions.push(new cc.Sequence(
        new cc.ScaleTo(0.325, 1.03),
        new cc.ScaleTo(0.325, 1),
        new cc.DelayTime(0.1)
    ));
    const mapView = Map2d.currentMap.getMapView();
    const startingPosition = mapView.alignInGrid(this.unit.x, this.unit.y);
    if (this.unit.distanceTo(target) !== 0 && this.unit !== target) {
        const targetPosition = mapView.alignInGrid(target.x, target.y);
        const position = mapView.alignInGrid(this.unit.x, this.unit.y);
        let dx = targetPosition.x - position.x;
        let dy = targetPosition.y - position.y;

        const length = Math.sqrt(dx * dx + dy * dy);
        dx = dx / length * cleverapps.styles.UnitView.merge;
        dy = dy / length * cleverapps.styles.UnitView.merge;

        if (this.unit.distanceTo(target) > 2) {
            dx /= 2;
            dy /= 2;
        }

        if (cleverapps.gameModes.automerge && Map2d.currentMap.advice && !Map2d.currentMap.advice.hintActive) {
            actions.push(new cc.Sequence(
                new cc.MoveBy(0.33, -dx, -dy).easing(cc.easeBackOut()),
                new cc.DelayTime(0.2),
                new cc.MoveBy(0.22, dx, dy).easing(cc.easeBackIn())
            ));
        } else {
            actions.push(new cc.Sequence(
                new cc.CallFunc(() => {
                    cleverapps.effects.fire("merge.hint");
                }),
                new cc.MoveBy(0.450, dx, dy).easing(cc.easeBackIn()),
                new cc.MoveBy(0.2, -dx, -dy).easing(cc.easeOut(2)),
                new cc.DelayTime(0.1)
            ));
        }
    }

    if (actions.length > 0) {
        const action = actions.length === 1 ? actions[0] : new cc.Spawn(actions);
        this.mergeAnimateAction = this.runAction(new cc.RepeatForever(action)).setFinalize(() => {
            this.setPosition(startingPosition);
        });
    }
};

UnitView.prototype.handleDragStart = function (touch) {
    if (!this.unit.handleDragStart()) {
        return false;
    }

    this.stopAllActions();

    InfoView.CloseInfo();

    this.unit.hideAdditionalViews();

    this.dragNode = new cc.Node();
    const movingNode = cleverapps.Scenes.GetRunningScene().movingNode;
    movingNode.addChild(this.dragNode);
    const scale = cc.Base.AdjustScaleTo(this, movingNode);
    this.dragNode.setScale(scale.x, scale.y);
    this.replaceParentSamePlace(this.dragNode);

    if (this.composite) {
        this.composite.createParts();
    }

    const position = this.parent.convertToNodeSpace(touch.getStartLocation());
    this.startDragDelta = cc.p(this.x - position.x, this.y - position.y);

    this.debugDeltaCreate = {
        when: new Date(),
        stack: new Error().stack
    };

    if (this.unit.findComponent(Shine) || this.unit.findComponent(Chest) || this.unit.findComponent(Fruit)) {
        const path = this.path = new cleverapps.Particles(bundles.particle.jsons.particles_drag_json, bundles.particle.frames.particle_texture);
        path.setScale(1 / Map2dScroller.currentScroller.getScrollZoom());
        path.setPosition(this.width / 2, this.height / 2);
        this.addChild(path);
        path.setLocalZOrder(-1);
    }

    if (this.sprite instanceof cleverapps.Spine && this.sprite.hasAnimation("fly")) {
        this.sprite.setCompleteListener();
        this.sprite.setAnimation(0, "fly", true);
        this.sprite.setSafeToRemove();
    }

    this.dragStartTime = Date.now();
    const dragOffsetY = cleverapps.styles.UnitView.dragOffsetY;
    this.runAction(new cc.MoveBy(0.1, 0, dragOffsetY));

    cleverapps.effects.fire("merge.drag.start");

    return true;
};

UnitView.prototype.handleFollowPointer = function (touch) {
    if (!this.startDragDelta) {
        cleverapps.throwAsync(`handleFollowPointer without delta - ${JSON.stringify({
            code: this.unit.code,
            stage: this.unit.stage,
            deltaCreate: this.debugDeltaCreate,
            deltaDelete: this.debugDeltaDelete
        })}`);
    }

    const position = this.parent.convertTouchToNodeSpace(touch);

    if (this.startDragDelta) {
        position.x += this.startDragDelta.x;
        position.y += this.startDragDelta.y;
    }

    let dragOffsetY = cleverapps.styles.UnitView.dragOffsetY;
    if (this.dragStartTime) {
        dragOffsetY *= Math.min(1, (Date.now() - this.dragStartTime) / 100);
    }
    position.y += dragOffsetY;

    this.setAlignment(position);
};

UnitView.prototype.handleDragMove = function () {
    const mapView = Map2d.currentMap.getMapView();
    const move = mapView.getCellByCoordinates(mapView.convertToNodeSpace(this.parent.convertToWorldSpace(this.getPosition())), true);
    this.unit.handleDragMove(move.x, move.y);
};

UnitView.prototype.removePath = function () {
    if (this.path) {
        this.path.stop();
        this.path = undefined;
    }
};

UnitView.prototype.handleDragEnd = function (cancelled) {
    this.debugDeltaDelete = {
        when: new Date(),
        stack: new Error().stack
    };

    this.markNormal();

    this.removePath();

    if (this.sprite instanceof cleverapps.Spine && this.sprite.hasAnimation("fly")) {
        this.sprite.setAnimation(0, "fall", false);
        this.sprite.setCompleteListener(() => {
            UnitView.applyDefaultAnimation(this.sprite, this.unit);

            this.unit.showAdditionalViews();
        });
        this.sprite.setSafeToRemove();
    } else {
        this.unit.showAdditionalViews();
    }
    const unitData = this.unit.getData();
    if (unitData.tank || unitData.customer) {
        if (cleverapps.config.name === "wondermerge") {
            cleverapps.effects.fire("merge.spawn.landing");
        }
        this.sprite.runAction(new cc.Sequence(
            new cc.DelayTime(0.23),
            cleverapps.effects.fireAction(`unit.fall.${this.unit.code}`, this)
        ));
    }

    const skin = cleverapps.skins.getSlot("unitMoveAnimation");
    if (skin) {
        const animation = new cleverapps.Spine(skin.json);
        animation.setAnimation(0, "animation", false);
        animation.setCompleteListenerRemove();
        animation.setAlignment(this.width / 2, this.sprite.y + (1 - this.sprite.anchorY) * this.sprite.height * this.sprite.scaleY);
        animation.setLocalZOrder(skin.zOrder);
        animation.setSafeToRemove();
        this.addChild(animation);

        cleverapps.effects.fire("unit.move_animation", this);
    }

    delete this.startDragDelta;
    delete this.dragStartTime;

    this.replaceParentSamePlace(Map2d.currentMap.getMapView().animations);
    if (this.dragNode) {
        this.dragNode.removeFromParent();
        delete this.dragNode;
    }

    this.unit.handleDragEnd(cancelled);
};

UnitView.prototype.markNormal = function () {
    if (this.sprite) {
        this.sprite.setColor(this.sprite.normalColor || cleverapps.styles.COLORS.WHITE);
    }
};

UnitView.prototype.markDragging = function () {
    if (this.sprite) {
        this.sprite.setColor(cleverapps.styles.COLORS.DRAGGING_UNIT_COLOR);
    }
};

UnitView.prototype.markDragTarget = function () {
    if (this.sprite) {
        this.sprite.setColor(cleverapps.styles.COLORS.DRAGG_TARGET_UNIT_COLOR);
    }
};

UnitView.prototype.markError = function () {
    if (this.sprite) {
        this.sprite.setColor(cleverapps.styles.COLORS.COLOR_RED);
    }
};

UnitView.prototype.move = function (options) {
    this.moving = true;
    options = options || {};
    const mapView = Map2d.currentMap.getMapView();

    for (const type in this.additionalViews) {
        const view = this.additionalViews[type];
        view.replaceParent(this);
        view.setAlignment(view.basePosition);
    }

    let pos = mapView.alignInGrid(this.unit.x, this.unit.y);
    if (this.unit.isMultiCell()) {
        pos = mapView.alignPositionInGrid(
            this.unit.x,
            this.unit.y,
            MultiCellView.calcCenterPosition(this.unit.findComponent(MultiCell).shape, this)
        );
    }
    this.setScale(1);
    this.setVisible(true);
    this.stopAllActions();
    this.removePath();

    this.replaceParentSamePlace(mapView.animations);

    if (this.composite) {
        this.composite.createParts();
    }

    const actions = [];
    if (options.isNewPlace) {
        actions.push(StandartAnimations.fallDown(this, bundles.merge_animations.jsons.dragend_json));
    } else {
        actions.push(new cc.MoveTo(0.25, pos).easing(cc.easeOut(2)));
        if (!options.isPushed) {
            actions.push(cleverapps.effects.fireAction(this.unit.isMultiCell() ? "merge3.unit.fall.multicell" : "merge3.unit.fall"));
        }
    }

    this.runAction(new cc.Sequence(actions).setFinalize(() => {
        mapView.addTile(Map2d.LAYER_UNITS, this.unit.x, this.unit.y, this);

        this.moving = false;

        for (const type in this.additionalViews) {
            const view = this.additionalViews[type];
            mapView.upAdditionalViewAboveClouds(this, view);
        }
    }));
};

UnitView.GetUnitBundle = function (unit) {
    if (!Families[unit.code] || !Families[unit.code].units[unit.stage]) {
        throw new Error(`No such unit ${unit.code}_${unit.stage}`);
    }
    const data = Families[unit.code].units[unit.stage];
    if (data.lazy) {
        return bundles[`unit_${unit.code}_${unit.stage + 1}`];
    }
    if (Families[unit.code].customTexture) {
        return bundles[`unit_${unit.code}_${cleverapps.meta.selectedLocationId()}`];
    }
    return bundles[`unit_${unit.code}`];
};

UnitView.UnitIconFrame = function (unit, customStatic) {
    const unitKey = `unit_${unit.code}_${unit.stage + 1}`;
    const bundle = UnitView.GetUnitBundle(unit);
    let res = bundle.frames[unitKey] || bundle.frames[`${unitKey}_frame`];
    if (customStatic || (res && res.key === unitKey && !res.resolve())) {
        const staticFrame = bundle.frames[`${unitKey}_frame`];
        res = staticFrame && staticFrame.resolve() ? staticFrame : bundle.frames[unitKey] || res;
    }
    return res && res.resolve();
};

UnitView.UnitIconJson = function (unit) {
    const unitKey = `unit_${unit.code}_${unit.stage + 1}`;
    const bundle = UnitView.GetUnitBundle(unit);
    const res = bundle.jsons[unitKey];
    return res && res.resolve();
};

UnitView.getUnitAnchor = function (unit, options) {
    options = options || {};

    const anchors = { x: 0.5, y: 0.5 };

    const res = UnitView.UnitIconJson(unit) || UnitView.UnitIconFrame(unit);
    const data = res && res.getAnchors();
    if (!data) {
        return anchors;
    }

    if (data.x !== undefined) {
        anchors.x = data.x;
    }

    if (data.y !== undefined) {
        anchors.y = data.y;
    }

    if (options.useLibraryAnchors) {
        anchors.y = 0.5;

        if (anchors.library && anchors.library.x !== undefined) {
            anchors.x = anchors.library.x;
        }

        if (anchors.library && anchors.library.y !== undefined) {
            anchors.y = anchors.library.y;
        }
    }

    if (options.podiumAnchors && data.podium) {
        anchors.x = data.podium.x;
        anchors.y = data.podium.y;
    }

    return anchors;
};

UnitView.getUnitAnimations = function (unit) {
    return cleverapps.skins.getSlot("unitDefaultAnimations", unit) || cleverapps.styles.UnitAnimations[unit.code] && cleverapps.styles.UnitAnimations[unit.code][`stage${unit.stage + 1}`];
};

UnitView.getPreview = function (unit, res, options) {
    let preview;

    const data = Families[unit.code].units[unit.stage];
    if (data.lazy) {
        preview = new cleverapps.Spine(bundles.lazypreview.jsons.preview);
        if (options.preferStatic && !preview.hasAnimation("static")) {
            preview = new cleverapps.Spine(bundles.lazypreview.jsons.preview_static);
        }
        preview.setAnchorPoint(options.useLibraryAnchors ? 0.5 : cleverapps.styles.UnitView.preview.anchorX, options.useLibraryAnchors ? 0.5 : cleverapps.styles.UnitView.preview.anchorY);
        preview.setAnimation(0, options.preferStatic ? "static" : "animation", true);
    } else {
        preview = UnitView.getUnitImage({ code: "unknown", stage: 0 }, {
            preferStatic: options.preferStatic,
            useLibraryAnchors: options.useLibraryAnchors,
            alignAnchorX: options.alignAnchorX,
            alignAnchorY: options.alignAnchorY
        });
    }

    const anchors = UnitView.getUnitAnchor(unit, options);
    const dimensions = res.getDimensions() || preview.getContentSize();

    preview.setAnchorPoint(
        preview.anchorX + dimensions.width / preview.width * (0.5 - anchors.x),
        preview.anchorY + dimensions.height / preview.height * (0.5 - anchors.y)
    );

    return preview;
};

UnitView.getUnitImage = function (unit, options) {
    options = options || {};
    const code = unit.code;

    if (unit.unknown) {
        return new cc.Sprite(bundles.merge.frames.unit_unknown);
    }

    const json = UnitView.UnitIconJson(unit);
    const frame = UnitView.UnitIconFrame(unit, options.customStatic);

    if (!json && !frame) {
        const virtualName = `unit_${code}_${unit.stage + 1}`;
        const virtualBundle = bundles[virtualName];
        const injectTo = (virtualBundle && virtualBundle.injectTo) || [];
        const real = injectTo[0];
        const realBundle = real && bundles[real];
        const handle = real && cleverapps.bundleLoader.getHandle(real);
        const hasJson = (bundle) => Boolean(bundle && bundle.jsons && bundle.jsons[virtualName]);
        const data = Families[code] && Families[code].units[unit.stage];
        const diag = [
            `lazy=${Boolean(data && data.lazy)}`,
            `injectTo=${injectTo.join(",")}`,
            `vExists=${Boolean(virtualBundle)}`,
            `vJson=${hasJson(virtualBundle)}`,
            `rExists=${Boolean(realBundle)}`,
            `rJson=${hasJson(realBundle)}`,
            `loaded=${Boolean(real && cleverapps.bundleLoader.isLoaded(real))}`,
            `hasHandle=${Boolean(handle)}`,
            `counter=${handle && handle.counter}`,
            `preferred=${Boolean(real && cleverapps.lazyAssets.isPreferredBundle(real))}`,
            `prefN=${Object.keys(cleverapps.lazyAssets.preferred).length}`
        ];
        throw new Error(`Not found frame ${virtualName} | diag ${diag.join(" ")}`);
    }

    let image;

    if (frame && (options.preferStatic || !json)) {
        try {
            image = frame.isBundleLazy() ? new LazyAsset(frame, { preview: UnitView.getPreview(unit, frame, options), keepLazy: options.keepLazy }) : new cc.Sprite(frame);
        } catch (e) {
            throw new Error(`can't create unit sprite ${unit.code} ${unit.stage} ${frame} ${e}`);
        }
    }

    if (json && !(options.preferStatic && frame)) {
        try {
            image = json.isBundleLazy() ? new LazyAsset(json, { preview: UnitView.getPreview(unit, json, options), keepLazy: options.keepLazy }) : new cleverapps.Spine(json);
        } catch (e) {
            throw new Error(`can't create unit spine ${unit.code} ${unit.stage} ${json} ${e}`);
        }

        UnitView.applyDefaultAnimation(image, unit, options.defaultAnimation, options.preferStatic);
    }

    const useAnchorBone = image.getAnchorBone && image.getAnchorBone();

    if (!useAnchorBone) {
        const anchors = UnitView.getUnitAnchor(unit, options);
        anchors.x = options.alignAnchorX || options.useLibraryAnchors ? anchors.x : 0.5;
        anchors.y = options.alignAnchorY || options.useLibraryAnchors ? anchors.y : 0.5;
        image.setAnchorPoint(anchors.x, anchors.y);
    }

    if (cleverapps.config.debugMode) {
        image.debugUnitImage = true;
    }

    return image;
};

UnitView.applyDefaultAnimation = function (animation, unit, defaultAnimation, preferStatic) {
    const applyDefaultAnimation = function () {
        const animations = UnitView.getUnitAnimations(unit);
        if (defaultAnimation && animation.hasAnimation(defaultAnimation)) {
            animation.setCompleteListener();
            animation.setAnimation(0, defaultAnimation, true);
        } else if (animations) {
            animation.setIdleSet(animations);
        } else if (animation.hasAnimation("idle")) {
            animation.setCompleteListener();
            animation.setAnimation(0, "idle", true);
        } else if (animation.hasAnimation("animation")) {
            animation.setCompleteListener();
            animation.setAnimation(0, "animation", true);
        } else if (animation.hasAnimation("animation_below")) {
            animation.setCompleteListener();
            animation.setAnimation(0, "animation_below", true);
        }

        animation.setSafeToRemove();
        if (unit.animateOutOfSync && unit.animateOutOfSync() && animation.getTimeScale() === 1) {
            animation.setTimeScale(0.9 + 0.3 * Math.random());
        }

        if (preferStatic) {
            animation.setAnimationFrame(0, 1);
            animation.clearTrack(0);
        }
    };

    if (animation instanceof LazyAsset) {
        animation.whenAssetLoaded(applyDefaultAnimation);
    } else {
        applyDefaultAnimation();
    }
};

UnitView.targetContainPoint = function (unitView, point, isTallUnit) {
    const a = cleverapps.styles.Map2dView.cell.width;
    const b = cleverapps.styles.Map2dView.cell.height;

    if (unitView.clickRect) {
        return cc.rectContainsPoint(unitView.clickRect, point);
    }

    let bottomPadding = 0;
    if (unitView.anchorY >= 0) {
        bottomPadding = Math.max(0, b * 0.25 - unitView.anchorY * unitView.height);
    }

    const sidePadding = Math.max(0, (0.5 - (unitView.sprite && unitView.sprite.anchorX) || 0) * unitView.width);

    let x = point.x - sidePadding;
    let y = point.y + bottomPadding;

    const width = unitView.width - sidePadding * 2;
    let height = unitView.height + bottomPadding;

    if (isTallUnit && unitView.height > b * 2) {
        height -= b;
    }

    if (x < 0 || x > width || y < 0 || y > height) {
        return false;
    }

    if (x > width / 2) {
        x = width - x;
    }

    if (y > height / 2) {
        y = height - y;
    }

    return width / 2 - a / b * y - x <= 0;
};

UnitView.prototype.playDestruction = function (silent, originUnit) {
    this.stopAllActions();
    this.removePath();

    if (originUnit) {
        this.explodeByProjectileAnimation(originUnit);
    } else if (this.unit && this.unit.getData().mineable && this.unit.getData().collectOnComplete) {
        cleverapps.effects.fire("merge.unit.destroy");
        const target = cleverapps.aims.getTarget(["questsGroupIcon", "warehouse"]);

        const collectImage = cleverapps.skins.getSlot("getUnitCollectImage", { unit: this.unit });
        if (collectImage) {
            collectImage.setAnchorPoint(0.5, 0.5);
            this.addChild(collectImage);
            collectImage.setPosition(this.width / 2, this.height / 2);
            collectImage.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(this));
            this.removeFromParent();

            collectImage.runAction(new cc.Sequence([
                StandartAnimations.animateCollect(collectImage, target, {
                    path: true,
                    adjustToTarget: true,
                    collectEffect: true
                }),
                new cc.RemoveSelf()
            ]));
        } else {
            this.runAction(new cc.Sequence([
                new cc.Show(),
                StandartAnimations.animateCollect(this, target, {
                    path: true,
                    adjustToTarget: true,
                    collectEffect: true
                }),
                new cc.Hide(),
                new cc.RemoveSelf()
            ]));
        }
    } else if (cleverapps.skins.getSlot("isometricExplode") || cleverapps.config.name === "hustlemerge") {
        this.isometricExplodeAnimation(silent);
    } else {
        this.explodeAnimation(silent);
    }
};

UnitView.prototype.isometricExplodeAnimation = function (silent) {
    const movingNode = cleverapps.Scenes.GetMovingNode(this);

    this.replaceParentSamePlace(movingNode);

    const animation = new cleverapps.Spine(bundles.merge_animations.jsons.isometric_explode_json || bundles.merge_animations.jsons.destruction_json);
    animation.setAnimation(0, "animation", false);
    animation.setCompleteListenerRemove(this.removeFromParent.bind(this));
    animation.setSafeToRemove();
    animation.setPosition(this.x, this.y);
    movingNode.addChild(animation, -1);

    if (this.unit.findComponent(Grounded)) {
        this.unit.findComponent(Grounded).remove();
    }

    cleverapps.effects.fire("merge.unit.destroy");

    if (!silent) {
        this.sprite.runAction(new cc.Sequence(
            new cc.ScaleTo(0.2, 1.3).easing(cc.easeIn(1)),
            new cc.Spawn(
                new cc.ScaleTo(0.1, 0.5).easing(cc.easeOut(1)),
                new cc.FadeTo(0.1, 180)
            ),
            new cc.Hide(),
            new cc.CallFunc(this.removeFromParent.bind(this))
        ));
    }
};

UnitView.prototype.explodeAnimation = function (silent) {
    const animation = new cleverapps.Spine(bundles.merge_animations.jsons.destruction_json);
    animation.setAlignment(this.width / 2, this.height / 2);
    animation.setAnimation(0, "animation", false);
    animation.setCompleteListenerRemove(this.removeFromParent.bind(this));
    animation.setSafeToRemove();
    this.addChild(animation);

    const movingNode = cleverapps.Scenes.GetMovingNode(this);

    this.replaceParentSamePlace(movingNode);
    animation.replaceParentSamePlace(movingNode);

    if (this.unit.findComponent(Grounded)) {
        this.unit.findComponent(Grounded).remove();
    }

    cleverapps.effects.fire("merge.unit.destroy");

    if (!silent) {
        this.runAction(
            new cc.Sequence(
                new cc.ScaleTo(0.2, 1.3, 1.3).easing(cc.easeIn(1)),
                new cc.ScaleTo(0.2, 0.5, 0.5).easing(cc.easeOut(1)),
                new cc.RemoveSelf()
            )
        );
    }
};

UnitView.prototype.explodeByProjectileAnimation = function (originUnit) {
    const originView = originUnit.onGetView();

    const animation = new cleverapps.Spine(bundles.axemerge.jsons.merge_projectile);
    animation.setAnimation(0, "idle", true);
    animation.setAlignment(cleverapps.styles.UnitView.projectile);
    animation.setSafeToRemove();
    originView.addChild(animation);

    const parent = cleverapps.Scenes.GetMovingNode(this);
    animation.replaceParentSamePlace(parent);
    const duration = 0.4;

    animation.runAction(new cc.Sequence(
        new cc.MoveTo(duration, parent.convertToNodeSpace(this.convertToWorldSpace(cc.p(this.width / 2, this.height / 2)))).easing(cc.easeInOut(1.4)),
        new cc.RemoveSelf()
    ));

    this.runAction(new cc.Sequence(
        new cc.DelayTime(duration - 0.02),
        new cc.CallFunc(this.explodeAnimation.bind(this, false))
    ));
};

UnitView.prototype.openAnimation = function () {
    this.stopAllActions();
    this.removePath();

    const animation = new cleverapps.Spine(bundles.merge_animations.jsons.appearance_json);
    animation.setAlignment(this.width / 2, this.height / 2);
    animation.setAnimation(0, "animation", false);
    animation.setCompleteListenerRemove(this.removeFromParent.bind(this));
    animation.setSafeToRemove();
    this.addChild(animation);

    animation.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(this));

    this.runAction(
        new cc.Sequence(
            new cc.ScaleTo(0.2, 1.3, 1.3).easing(cc.easeIn(1)),
            new cc.ScaleTo(0.2, 0.5, 0.5).easing(cc.easeOut(1)),
            new cc.RemoveSelf()
        )
    );
};

UnitView.prototype.playAddAnimation = function () {
    const map2dView = Map2d.currentMap.getMapView();
    const shine = new cleverapps.Spine(bundles.merge.jsons.buildable_above_json);
    shine.setLocalZOrder(1);
    shine.setAnimation(0, "animation_bonus", false);
    shine.setCompleteListenerRemove();
    shine.setSafeToRemove();
    map2dView.alignViewInGrid(this.unit.x, this.unit.y, shine);
    map2dView.animations.addChild(shine);

    this.setVisible(false);
    this.setScale(0.3);
    this.addAnimationAction = this.runAction(new cc.Sequence(
        new cc.DelayTime(0.3),
        cleverapps.effects.fireAction("thirdelement.appear"),
        new cc.Show(),
        new cc.ScaleTo(0.4, 1.3),
        new cc.ScaleTo(0.2, 1)
    ));
};

UnitView.prototype.updateCustomerMark = function () {
    if (cleverapps.config.demoMode || cleverapps.gameModes.hideGuideAndProgress) {
        return;
    }

    if (this.unit.customerMark) {
        const styles = cleverapps.styles.UnitView;
        const markBg = new cc.Sprite(bundles.customer_check_marks.frames.customer_check_mark_bg);
        markBg.setAnchorPoint(0, 0);
        markBg.setAlignment(styles.mark);

        const mark = new cc.Sprite(bundles.customer_check_marks.frames.customer_check_mark_flat);
        markBg.addChild(mark);
        mark.setAlignment(markBg.width / 2, markBg.height / 2);

        this.animateAppearAdditionalView("customerMark", markBg);
    } else {
        this.removeAdditionalView("customerMark");
    }
};

UnitView.prototype.createPrizeView = function () {
    this.removeAdditionalView("prize");

    const prizes = this.unit.prizes;
    if (prizes === undefined || cleverapps.config.demoMode) {
        return;
    }

    const prizeView = new PrizeView(prizes, {
        warning: this.unit.prizeWarning,
        onClick: this.handleClick.bind(this),
        unit: this.unit
    });
    prizeView.setAlignment(this.width / 2, this.height);
    this.createAdditionalView("prize", prizeView);
};

UnitView.prototype.animatePrizeView = function () {
    const prizeView = this.getAdditionalView("prize");
    if (prizeView && !this.unit.additionalViewsHidden) {
        prizeView.animateAppear();

        if (!cleverapps.gameModes.silentInfoView && !this.unit.findComponent(Bank) && !cleverapps.skins.getSlot("skipPrizeViewCreatedEffect")) {
            cleverapps.effects.fire("merge3.prize_view.created");
        }
    }
};

UnitView.prototype.createAdditionalView = function (type, view) {
    this.removeAdditionalView(type, true);

    const additionalView = new UnitAdditionalView(this, view, type);
    Map2d.currentMap.getMapView().upAdditionalViewAboveClouds(this, additionalView);
    this.additionalViews[type] = additionalView;

    if (this.unit.additionalViewsHidden) {
        additionalView.hide();
    }

    return additionalView;
};

UnitView.prototype.animateAppearAdditionalView = function (type, view) {
    const onHideCallback = function () {
        const additionalView = this.createAdditionalView(type, view);
        if (additionalView && !this.unit.additionalViewsHidden) {
            additionalView.animateAppear();
        }
    }.bind(this);
    const oldView = this.additionalViews[type];
    if (oldView) {
        oldView.animateHide(onHideCallback);
    } else {
        onHideCallback();
    }
};

UnitView.prototype.getAdditionalView = function (type) {
    return this.additionalViews[type];
};

UnitView.prototype.listAdditionalViews = function () {
    return Object.values(this.additionalViews).filter(Boolean);
};

UnitView.prototype.removeAdditionalView = function (type, silent) {
    const view = this.additionalViews[type];
    delete this.additionalViews[type];

    if (view) {
        view.remove(silent);
    }

    return view;
};

UnitView.prototype.setImageOpacity = function (opacity, temp) {
    if (!temp) {
        this.baseOpacity = opacity;
    }

    this.sprite.setOpacity(opacity);
};

UnitView.prototype.restoreOpacity = function () {
    this.sprite.setOpacity(this.baseOpacity !== undefined ? this.baseOpacity : 255);
};

UnitView.prototype.onDeletePressed = function () {
    if (!confirm(`Delete unit "${this.unit.code}'?`)) {
        return;
    }

    this.unit.remove();
    Map2d.currentMap.blockedGrounds.updateBlockedGrounds();
};

UnitView.prototype.getAnimation = function () {
    if (this.sprite instanceof cleverapps.Spine || (this.sprite instanceof LazyAsset && this.sprite.isSpine())) {
        return this.sprite;
    }
};

UnitView.prototype.hideSprite = function () {
    this.sprite.setVisible(false);

    if (this.sprite instanceof cleverapps.Spine) {
        this.sprite.setStartVisibleListener(() => {
            this.sprite.setVisible(false);
        });
    }
};

UnitView.prototype.showSprite = function () {
    this.sprite.setVisible(true);

    if (this.sprite instanceof cleverapps.Spine) {
        this.sprite.setStartVisibleListener(undefined);
    }
};

UnitView.prototype.animateAppearPoints = function () {
    this.restoreState();
    if (this.pointAnimation) {
        const styles = cleverapps.styles.UnitView.pointsAnimation;
        this.pointAnimation.setAlignment(this.pointAnimation.x, this.pointAnimation.y - styles.offsetY);
        this.pointAnimation.setScale(0.1);
        this.pointAnimation.runAction(new cc.ScaleTo(1, 1));
        this.pointAnimation.runAction(new cc.MoveBy(1, 0, styles.offsetY));
    }
};

UnitView.prototype.createPoints = function () {
    if (!this.unit.points) {
        return;
    }
    const styles = cleverapps.styles.UnitView.pointsAnimation;

    if (this.pointAnimation) {
        return;
    }

    const mission = cleverapps.missionManager.findByType(Mission.TYPE_SALEPASS);
    const isPurchaseBuildPass = mission && MissionManager.hasProperLocation(mission.type);
    const pointAnimation = this.pointAnimation = new cleverapps.Spine(isPurchaseBuildPass ? bundles.merge.jsons.salepass_point : bundles.merge.jsons.buildpass_point);
    pointAnimation.setAnchorPoint(0.5, 0.5);
    pointAnimation.setAlignment(styles);
    pointAnimation.setAnimation(0, isPurchaseBuildPass ? `${PassMissionLogic.classifyAmount(this.unit.points)}_idle` : "idle", true);
    pointAnimation.setSafeToRemove();
    this.addChild(pointAnimation);
    cleverapps.UI.onClick(pointAnimation, this.unit.claimPoints.bind(this.unit));

    if (cleverapps.gameModes.hideUnitPointAnimation) {
        pointAnimation.setVisible(false);
    }
};

UnitView.prototype.hidePoints = function () {
    const styles = cleverapps.styles.UnitView.pointsAnimation;

    if (this.pointAnimation) {
        this.pointAnimation.stopAllActions();
        this.pointAnimation.runAction(new cc.ScaleTo(0.3, 0.1));
        this.pointAnimation.runAction(new cc.Sequence(
            new cc.MoveBy(0.3, 0, -styles.offsetY),
            new cc.RemoveSelf()
        ));
        delete this.pointAnimation;
    }
};

UnitView.prototype.claimPoints = function (callback) {
    if (!this.pointAnimation) {
        callback();
        return;
    }

    const pointAnimation = this.pointAnimation;
    this.pointAnimation = undefined;

    pointAnimation.stopAllActions();
    pointAnimation.replaceParentSamePlace(cleverapps.Scenes.GetRunningScene(), {
        keepScale: true
    });

    const passMission = cleverapps.missionManager.findLocalPass();
    if (!passMission) {
        this.hidePoints();
        return;
    }

    pointAnimation.runAction(new cc.Sequence(
        StandartAnimations.animateCollect(pointAnimation, `mission${passMission.type}`, {
            adjustToTarget: true,
            collectEffect: true,
            effect: "menubar.exp.fly_finish"
        }),
        new cc.CallFunc(callback),
        new cc.RemoveSelf()
    ));
};

UnitView.prototype.getDnDAccepted = function (targetUnit) {
    const mapView = Map2d.currentMap.getMapView();

    this.replaceParentSamePlace(mapView.animations, {
        keepScale: true
    });

    const startPosition = this.getPosition();
    const finishPosition = mapView.getUnitCenterPos(targetUnit.x, targetUnit.y);
    const distance = cc.pDistance(startPosition, finishPosition);

    this.runAction(new cc.Sequence(
        new cc.JumpTo((0.004 * distance + 0.1) / (0.008 * distance + 1), finishPosition.x, finishPosition.y, 0.3 * distance, 1),
        cleverapps.effects.fireAction("merge.fruit_fly.finish"),
        new cc.RemoveSelf()
    ));
};

UnitView.prototype.animateFlinch = function () {
    this.sprite.runAction(new cc.Sequence(
        new cc.ScaleTo(0.1, 1.15).easing(cc.easeIn(1.2)),
        new cc.ScaleTo(0.1, 1).easing(cc.easeOut(1.2))
    ));
};

UnitView.prototype.collectIngredients = function (parentUnit, collected, callback) {
    const target = cleverapps.aims.getTarget(["warehouse"]);

    const movingNode = Map2d.currentMap.getMapView().animations;

    const startPosition = Map2d.currentMap.getMapView().alignInGrid(parentUnit.x, parentUnit.y);
    const multiCell = parentUnit.findComponent && parentUnit.findComponent(MultiCell);
    if (multiCell) {
        const centerDelta = multiCell.getCenter();
        startPosition.x += centerDelta.x;
        startPosition.y += centerDelta.y;
    }

    const groups = {};

    collected.forEach((prize) => {
        if (!groups[prize.ingredient]) {
            groups[prize.ingredient] = 0;
        }

        groups[prize.ingredient] += prize.amount;
    });

    const actions = [];

    let delay = 0;

    Object.keys(groups).forEach((code, groupIndex, total) => {
        const delta = groups[code];

        let flyingAmount;

        if (delta >= 100) {
            flyingAmount = 8;
        } else if (delta >= 50) {
            flyingAmount = 5;
        } else if (delta >= 3) {
            flyingAmount = 3;
        } else {
            flyingAmount = delta;
        }

        delay -= delay / 2;

        cleverapps.arrayFill(flyingAmount).forEach((value, index) => {
            const item = Map2dLocation.currentLocation.harvested.getIngredientSmallIcon(code);
            item.setAlignment(startPosition);
            movingNode.addChild(item);

            item.setLocalZOrder(1 / (1 + index));
            item.setVisible(false);

            delay += Math.random() * 0.1;

            const action = [
                new cc.DelayTime(delay),
                new cc.Show(),
                StandartAnimations.jumpCollect(item, target, {
                    collectMovingNode: cleverapps.focusManager.currentWindow() && movingNode,
                    jumpOffset: index / flyingAmount,
                    longJump: cleverapps.skins.getSlot("useLongJumpAnimation"),
                    collectDelay: 0.1 * total.length + 0.1 * groupIndex,
                    jumpCollectEffect: cleverapps.skins.getSlot("jumpCollectEffect"),
                    collectSoundEffect: "merge.fruit_fly.finish",
                    timeScale: Map2d.animationsTimeScale()
                }),
                new cc.RemoveSelf()
            ];

            delay += 0.1;

            if (index === flyingAmount - 1) {
                action.push(new cc.CallFunc(() => {
                    cleverapps.aims.showDelta(delta, target, {
                        icon: Map2dLocation.currentLocation.harvested.getIngredientSmallIcon(code)
                    });
                }));
            }

            const itemAction = new cc.Sequence(action);

            actions.push(new cc.Sequence(
                new cc.CallFunc(() => {
                    item.runAction(itemAction);
                }),
                new cc.DelayTime(itemAction.getDuration())
            ));
        });
    });

    if (actions.length === 0) {
        return;
    }

    if (actions.length === 1) {
        movingNode.runAction(actions[0]);
    } else {
        movingNode.runAction(new cc.Spawn(actions));
    }

    movingNode.runAction(new cc.Sequence(
        new cc.DelayTime(delay + (cleverapps.skins.getSlot("useLongJumpAnimation") ? 0.8 : 0.4)),
        new cc.CallFunc(callback)
    ));
};

UnitView.prototype.setPartsVisible = function (visible) {
    if (this.composite) {
        this.composite.setVisible(visible);
    }
};

UnitView.prototype.showPartsUp = function () {
    if (this.composite) {
        this.composite.showPartsUp();
    }
};

UnitView.runUpgradeAnimation = function (nodeOld, nodeNew, options) {
    const partsTarget = nodeNew && nodeNew.showPartsUp ? nodeNew : null;
    return StandartAnimations.upgrade(nodeOld, nodeNew, {
        ...options,
        onHidden: () => partsTarget && partsTarget.setPartsVisible(false),
        onShowStart: () => partsTarget && partsTarget.showPartsUp()
    });
};

UnitView.prototype.markLast = function () {
    const bundle = bundles.merge.jsons.mark_last_json;
    if (!bundle) {
        return;
    }

    if (!this.markLastAnimation) {
        this.markLastAnimation = new cleverapps.Spine(bundle);
    }

    const mark = this.markLastAnimation;

    mark.setAnimation(0, "idle", true);
    mark.setAlignment(cleverapps.styles.UnitView.markLast);

    this.addChild(mark);
};

UnitView.prototype.canSmile = function () {
    return this.sprite instanceof cleverapps.Spine
        && this.sprite.hasAnimation("smile")
        && this.getNumberOfRunningActions() === 0;
};

UnitView.prototype.smile = function () {
    if (this.sprite.isVisible()) {
        this.sprite.setAnimationAndIdleAfter("smile", "idle");
    }
};

UnitView.prototype.canHideTile = function () {
    const inAction = this.getNumberOfRunningActions() > 0
        || this.sprite instanceof cleverapps.Spine && !this.sprite.isSaveToRemove();

    return !inAction;
};

UnitView.prototype.calcScrollOptionsForAdditionalView = function (additionalView) {
    const sceneSize = cleverapps.resolution.getSceneSize();
    let zoom = Map2dScroller.currentScroller.zoom;
    const padding = cleverapps.styles.UnitView.additionalViewTopPadding;

    const requiredHeight = (additionalView.view.height + this.height) * zoom;
    const availableHeight = 0.9 * sceneSize.height;
    if (requiredHeight > availableHeight) {
        zoom *= availableHeight / requiredHeight;
    }

    const neededAboveCenterPx = (additionalView.view.height + this.height / 2) * zoom + padding;
    const offsetY = -Math.max(neededAboveCenterPx - sceneSize.height / 2, 0);

    return { centerOffset: { x: 0, y: offsetY }, zoom, keepZoom: true };
};

cleverapps.styles.UnitAnimations = {};

cleverapps.styles.UnitView = {
    merge: 16,
    pushingLength: 15,
    preview: { anchorX: 0.47, anchorY: 0.28 },
    minimalSize: {
        width: 108,
        height: 80
    },

    enableSpawnPath: true,
    spawnHeight: 240,
    mergeSpawnHeight: 70,
    dragOffsetY: 30,
    additionalViewTopPadding: 120,

    pointsAnimation: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 60 },
        offsetY: 50
    },

    mergeAnimation: {
        x: 0,
        y: 0,
        delay: 0.2
    },

    mergeAnimationBelow: {
        x: 0,
        y: 0,
        delay: 0.2
    },

    didMerge: {
        delay: 0.6
    },

    mark: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -50 }
    },

    projectile: {
        x: { align: "center" },
        y: { align: "center", dy: -40 }
    },

    dragend: {
        x: { align: "center" },
        y: { align: "center" }
    },

    markLast: {
        x: { align: "center", dx: -35 },
        y: { align: "bottom", dy: -5 }
    },

    delta: {
        moveRate: 0.3
    },

    squeeze: {
        smallHeight: 100
    }
};
